export const TokenType = {
  SPACE: ' '.charCodeAt(0),
  PAR_OPEN: '('.charCodeAt(0),
  PAR_CLOSE: ')'.charCodeAt(0),
  NOT: '!'.charCodeAt(0),
  AND: '&'.charCodeAt(0),
  OR: '|'.charCodeAt(0),
  EQUALS: '='.charCodeAt(0),
  LITERAL: 'LITERAL',
  END: 'END',
  LEAF: 'LEAF',
  ATOMIC: 'ATOMIC',
};

function Tokenizer(exp: string) {
  let literal = '';
  const tokens: { type: string | number; value: string }[] = [];
  const pushLiteral = () => {
    tokens.push({ type: TokenType.LITERAL, value: literal });
    literal = '';
  };

  for (const char of exp) {
    const code = char.charCodeAt(0);
    switch (code) {
      case TokenType.SPACE: {
        if (literal) pushLiteral();
        break;
      }

      case TokenType.PAR_OPEN:
      case TokenType.PAR_CLOSE:
      case TokenType.NOT:
      case TokenType.AND:
      case TokenType.OR:
      case TokenType.EQUALS: {
        if (literal) pushLiteral();
        tokens.push({ type: code, value: char });
        break;
      }

      default: {
        literal += char;
      }
    }
  }

  if (literal) pushLiteral();

  return tokens;
}

export default Tokenizer;
